function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.9 10.876c0-1.445 1.173-2.63 2.604-2.63h40.57c1.442 0 2.605 1.185 2.605 2.63V32.64c0 1.455-1.164 2.63-2.605 2.63H7.505c-1.432 0-2.605-1.175-2.605-2.63z",
  fill: "#fff",
  fillRule: "evenodd"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M33.84 16.982c0-.64.526-1.164 1.165-1.164.644 0 1.164.525 1.164 1.164 0 .645-.52 1.164-1.165 1.164-.64 0-1.164-.52-1.164-1.164z",
  fill: "#adb9ca",
  fillRule: "evenodd"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.85 5.597h3.872V1.2L54.75 9.993l-11.028 8.793V14.39H39.85z",
  className: "icon-primary",
  fill: "#ecaec6",
  fillRule: "evenodd"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M39.502 5.51h4.014V.997l11.734 9.126-11.734 8.927v-4.513h-4.014z",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001,
  strokeLinecap: "round",
  strokeMiterlimit: 8
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  strokeMiterlimit: 8,
  d: "M50.49 17.53c-.026 5.89.026 9.49 0 15.38 0 1.452-1.286 2.625-2.877 2.625H7.43c-1.586 0-2.878-1.172-2.878-2.625V11.176c0-1.448 1.293-2.626 2.878-2.626H35.5",
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001
});

var _ref7 =
/*#__PURE__*/
React.createElement("g", {
  className: "icon-tertiary",
  fill: "none",
  stroke: "#002060",
  strokeWidth: 0.80000001
}, React.createElement("path", {
  d: "M33.452 17c0-.843.692-1.535 1.535-1.535.85 0 1.536.692 1.536 1.535 0 .85-.686 1.535-1.536 1.535-.843 0-1.535-.685-1.535-1.535",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10
}), React.createElement("path", {
  d: "M9.5 13.05v17.5H46"
}), React.createElement("path", {
  d: "M12 27l8-5 8 1 5.816-4.78"
}));

var SvgMenuRunsurvey = function SvgMenuRunsurvey(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 60,
    height: 36,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMenuRunsurvey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Menu-runsurvey.c77ce703.svg";
export { ForwardRef as ReactComponent };